import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { Checkbox, Form } from 'semantic-ui-react'
import { KeyLabelType } from '~/types'
interface Props {
  calfRearing: any
  update: (index: number, value: string) => void
  index: number
  calfType: KeyLabelType
}

const CalfRearingCell: React.FC<Props> = (props) => {
  const { control } = useFormContext()
  const { calfRearing, index, update, calfType } = props

  const watchWeaningWeeksValue = useWatch({ control, name: `weaningWeeksValues[${index}].calfRearing` })

  return <Controller
    control={control}
    name={`weaningWeeksValues[${index}].calfRearing`}
    rules={{
      required: true
    }}
    render={({ fieldState }) => (
      <Form.Field error={fieldState.error ? !watchWeaningWeeksValue : false}>
        <Checkbox
          key={calfType.label + index}
          id={calfType.label + index}
          onChange={() => update(index, calfType.key)}
          label={''}
          checked={watchWeaningWeeksValue === calfType.key}
        />
      </Form.Field>
    )}
  />
}
export default CalfRearingCell